import * as React from "react";
import { SVGProps } from "react";
function SvgLoaderIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 4a8 8 0 1 0 8 8h-2a6 6 0 1 1-6-6V4Z"
        fill="#000"
        fillOpacity={0.5}
      />
    </svg>
  );
}
export default SvgLoaderIcon;
